export default {
  dashBoard: 'Dashboard',
  treatmentReport: 'Treatment Report',
  queuePage: 'Queue Page',
  appointment: 'Appointment',
  patient: 'Patient',
  opdReport: 'OPD Report',
  doctor: 'Doctor',
  ingredient: 'Ingredient',
  drugFormulaList: 'Drug Formula List',
  product: 'Product',
  stock: 'Stock',
  pos: 'Cashier',
  posOrders: 'POS Orders',
  service: 'Service',
  course: 'Course',
  setting: 'Setting'
}
